import moment from "moment";

export const month = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
export const anotherUpdateDate = (params: any): string => {
    const d = new Date(params);
    const date =
      month[d.getMonth()] + ' ' + getModifiedDate(d) + ', ' + d.getFullYear();
    return date;
  };

export function getModifiedDate(d: any): string {
    const month = Number(d.getDate());
    let m = '';
    if (month <= 9) {
      m = '0' + month;
    } else {
      m += month;
    }
    return m;
  }


export const getCalendarTime = (dateString: any) => {
  // Parse the date string using Moment.js
  const parsedDate = moment(dateString);

  // Check if the parsed date is valid
  if (!parsedDate.isValid()) {
    return 'Invalid date';
  }

  // Format the parsed date in a calendar time format
  const calendarTime = parsedDate.calendar();
  return calendarTime;
};